import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	defaultTitle: {
		id: 'dtcPartnership.landing.title.default',
		defaultMessage: 'Welcome to Calm',
		description: 'Default page title for B2B',
	},
	activateLincolnMessage: {
		id: 'dtcPartnership.landing.activate.lincoln',
		defaultMessage: 'Activate 1 Year of Calm Premium for Free',
		description: 'The type of membership the user will receive',
	},
	offerMessage: {
		id: 'dtcPartnership.landing.offerMessage',
		defaultMessage: '{partnerName} is offering you a Calm Premium subscription',
		description: 'The type of membership the user will receive',
	},
	blueApronOfferMessage: {
		id: 'dtcPartnership.landing.blueApronOfferMessage',
		defaultMessage:
			'For a limited time, Blue Apron is offering{breakingLine}3-months of Calm Premium for free.',
		description: 'Custom offer message for Blue Apron',
	},
	peacockOfferMessage: {
		id: 'dtcPartnership.landing.peacockOfferMessage',
		defaultMessage: 'For a limited time, Peacock is offering{breakingLine}3-months of Calm Premium for free.',
		description: 'Custom offer message for Peacock',
	},
	peacockUpdatedOfferMessage: {
		id: 'dtcPartnership.landing.peacockUpdatedOfferMessage',
		defaultMessage: 'For a limited time, redeem 3-months of Calm Premium for free.',
		description: 'Custom offer message for Peacock',
	},
	optusOfferMessage: {
		id: 'dtcPartnership.landing.optusOfferMessage',
		defaultMessage: 'Congratulations! You are about to link a Calm Premium subscription to Optus SubHub',
		description: 'Custom offer message for Optus SubHub customers',
	},
	logitechOfferMessage: {
		id: 'dtcPartnership.landing.logitechOfferMessage',
		defaultMessage: 'Redeem your 3-months of Calm Premium for free from Logitech',
		description: 'Custom offer message for Logitech',
	},
	fitbitOfferMessage: {
		id: 'dtcPartnership.landing.fitbitOfferMessage',
		defaultMessage:
			'For a limited time, activate your Fitbit Premium membership when you purchase a new Sense advanced smartwatch on Fitbit.com to receive a 6-month subscription to Calm',
		description: 'Custom offer message for Fitbit',
	},
	gerberSuccessCopy: {
		id: 'partner.success.gerberSuccessCopy',
		defaultMessage:
			'You have access to <bold>Calm Premium!</bold>{breakingLine}We recommend downloading the Calm app and starting your journey there.{breakingLine}After downloading the app, {login} to unlock the premium content.{breakingLine}Find calm with our "For Parents" Collection',
		description: 'Custom success message for Gerber',
	},
	gerberSuccessCTA: {
		id: 'partner.success.gerberSuccessCTA',
		defaultMessage: 'Listen Now',
		description: 'Custom success call to action for Gerber',
	},
	singtel1mActivate: {
		id: 'dtcPartnership.landing.singtel1mActivate',
		defaultMessage: 'Singtel is offering you a 1 month Calm Premium subscription',
		description: 'Custom headline for Singtel 1m',
	},
	singtel3mActivate: {
		id: 'dtcPartnership.landing.singtel3mActivate',
		defaultMessage: 'Singtel is offering you a 3 month Calm Premium subscription',
		description: 'Custom headline for Singtel 3m',
	},
	singtel1yActivate: {
		id: 'dtcPartnership.landing.singtel1yActivate',
		defaultMessage: 'Singtel is offering you a 1 year Calm Premium subscription',
		description: 'Custom headline for Singtel 1y',
	},
	eeActivate: {
		id: 'dtcPartnership.landing.eeActivate',
		defaultMessage: 'Thank you for choosing a Calm Premium subscription through EE.',
		description: 'Custom headline for EE partnership',
	},
});
